import { PopoverInteractionKind, Tag } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import React from "react";
import type { Position } from ".";
import { renderTagTooltip } from "../../../../utils/metadata-formatter";
import { NAME_GAP, TAGS_DELTA_Y } from "./constants";

export const GenomesTreeNodeTags = ({ p, tags }: { p: Position; tags: string[] }) => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <foreignObject
      style={{ transform: `translate(${p[0] + NAME_GAP}px, ${p[1] + TAGS_DELTA_Y}px)` }}
      width={10000 /* Pseudo-Infinity */}
      height={20}
    >
      {tags.map((tag) => (
        <Popover2
          key={tag}
          interactionKind={PopoverInteractionKind.HOVER}
          placement="top"
          content={renderTagTooltip(tag)}
          popoverClassName="info-tooltip"
        >
          <Tag className="genome-tag">{tag}</Tag>
        </Popover2>
      ))}
    </foreignObject>
  );
};
